// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { sineGraph16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-sine-graph': IconSineGraph;
    }
}

/**
 * The icon component for the 'sineGraph' icon
 */
export class IconSineGraph extends IconSvg {
    public constructor() {
        super(sineGraph16X16);
    }
}

registerIconSvg('icon-sine-graph', IconSineGraph);
export const iconSineGraphTag = 'nimble-icon-sine-graph';
